(() => {
  const MOBILE_QUERY = '(max-width: 768px)';
  const SCROLL_OFFSET = 124;
  const GOLF_COLLECTION_PATH = '/collections/golf-collection';

  function isGolfCollectionPage() {
    return window.location.pathname.indexOf(GOLF_COLLECTION_PATH) === 0;
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        window.clearInterval(timer);
        callback();
        return;
      }
      if (attempts >= 100) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  function destroyPromoSwiper(section) {
    if (!section._promoSwiper) return;
    section._promoSwiper.destroy(true, true);
    section._promoSwiper = null;
  }

  function createPromoSwiper(section) {
    const el = section.querySelector('[data-golf-promo-swiper]');
    if (!el || section._promoSwiper) return;

    const paginationEl = section.querySelector('[data-golf-promo-pagination]');
    const slideCount = el.querySelectorAll('.swiper-slide').length;

    section._promoSwiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      slidesPerGroup: 1,
      speed: 400,
      watchOverflow: true,
      threshold: 10,
      preventClicks: true,
      preventClicksPropagation: false,
      pagination:
        paginationEl && slideCount > 1
          ? {
              el: paginationEl,
              clickable: true,
              bulletClass: 'golf-collection-promo__dot',
              bulletActiveClass: 'is-active',
              renderBullet(index, className) {
                return `<button type="button" class="${className}" aria-label="Group ${index + 1}"></button>`;
              },
            }
          : undefined,
      breakpoints: {
        769: {
          slidesPerView: 3,
          spaceBetween: 8,
          slidesPerGroup: 3,
        },
      },
    });
  }

  function hasCollectionFilterParams() {
    const params = new URLSearchParams(window.location.search);
    for (const key of params.keys()) {
      if (key.startsWith('filter.')) return true;
    }
    return false;
  }

  function getFilterScrollTarget() {
    const sortBar = document.querySelector('.facets-vertical-sort');
    if (sortBar && sortBar.offsetParent !== null) return sortBar;
    return (
      document.getElementById('main-collection-filters') ||
      document.getElementById('ProductGridContainer')
    );
  }

  function scrollToFilterModule(behavior) {
    if (!isGolfCollectionPage()) return;
    const target = getFilterScrollTarget();
    if (!target) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = target.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    window.scrollTo({
      top: Math.max(top, 0),
      behavior: behavior || (prefersReducedMotion ? 'auto' : 'smooth'),
    });
  }

  // Only golf-collection: filtered URL deep-links land on the filter module
  function scrollToFilterIfFiltered() {
    if (!isGolfCollectionPage() || !hasCollectionFilterParams()) return;
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    const run = () => scrollToFilterModule('auto');
    requestAnimationFrame(run);
    window.addEventListener('load', run, { once: true });
  }

  // Opt-in hook for facets.js — other collection pages keep default scroll-to-top
  function registerFilterScrollHook() {
    if (!isGolfCollectionPage()) return;
    window.__golfCollectionScrollAfterFilter = () => scrollToFilterModule();
  }

  function initSection(section) {
    if (!section) return;
    destroyPromoSwiper(section);
    whenSwiperReady(() => createPromoSwiper(section));
  }

  function initAll() {
    document.querySelectorAll('[data-golf-promo]').forEach(initSection);
    registerFilterScrollHook();
    scrollToFilterIfFiltered();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-golf-promo]');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-golf-promo]');
    if (section) destroyPromoSwiper(section);
  });

  window.matchMedia(MOBILE_QUERY).addEventListener('change', () => {
    document.querySelectorAll('[data-golf-promo]').forEach(initSection);
  });
})();
